import React, { useState, useEffect } from 'react'

import { Col, Row, Typography, Button, Table, Tooltip   } from 'antd'
import { SearchOutlined, EyeOutlined } from '@ant-design/icons'

import { useNavigate  } from 'react-router-dom'

import InputMask from 'react-input-mask'
import { useForm } from 'react-hook-form'

import SearchPolicyStore from '../../store/slice/search.policy.slice'

import doUtility from '../utility'

import { Loader } from '../utility/componentUtility'

import toast from 'react-hot-toast'

const { Title } = Typography

const searchTypes = [
    { 'text': 'Policy #', 'slug': 'POL' },
    { 'text': 'CNIC', 'slug':'CNIC' },
    { 'text': 'Agent', 'slug': 'AGENT' }
]

const businessTypes = [
                        { 'text': 'Conventional', 'slug': 'CNV' },
                        { 'text': 'Takaful', 'slug':'TKF' },
                        { 'text': 'Both', 'slug': 'BOTH'}
                    ]

function IPolicyEnq () {

    const navigate =  useNavigate()

    const EnqNull  = SearchPolicyStore((state) => state.EnqNull)

    const Enq      = SearchPolicyStore((state) => state.Enq)

    const Policy_n = SearchPolicyStore((state) => state.Policy_n)

    let EnqResponse = SearchPolicyStore((state) => state.EnqResponse)
    
    const [optionChange, setOptionChange]               = useState('POL')
    const [policyDetail, setPolicyDetail]               = useState([])
    const [policyDetailColumn, setPolicyDetailColumn]   = useState([])
    const [loading, setLoading]                         = useState(false)

    const storageBusinessType                           = JSON.parse(localStorage.getItem('userDetails'))

    const handleChange = event => {
        setOptionChange(event.target.value);
    }

    const viewDetails = (record) => {
        if(record.Policy_No !== ""){
            SearchPolicyStore.setState({ Policy_n: record.Policy_No, EnqPolicyType: record.LOB_CODE })
        }
    }

    useEffect(()=>{
        
        if(EnqResponse){

            const action = {
                title: 'Action',
                key: 'action',
                render: (_, record) => (
                    <Tooltip placement="top" title={'View Details'}>
                        <Button type="default" icon={<EyeOutlined />} onClick={ () => viewDetails(record) }>
                        </Button>
                    </Tooltip>
                )
            }

            setLoading(false)

            const data = doUtility.RenderTableData(EnqResponse)            
            setPolicyDetail(data.datasource)
            
            if(data.column[0]['title'] !== 'Message'){
                setPolicyDetailColumn([...data.column, action])
            }else{
                setPolicyDetailColumn(data.column)
            }
            
        }else{
            setPolicyDetail([])
        }

    }, [EnqResponse, setLoading])

    useEffect(() => {
        if(Policy_n !== null){
            navigate('/dashboard/policyEnq/details', {state: {
                policy_no: Policy_n
            }})
            SearchPolicyStore.setState({ Policy_n: null})
            EnqNull()
        }
    },[Policy_n, navigate, EnqNull])

    const { register, handleSubmit, formState: { errors } } = useForm()

    const onSubmit = (data) => {
        if(data.value == null || data.value == ''){
            toast.error('Field Empty', { id: "copy" })
        }else{
            setLoading(true)
            EnqResponse = null
            Enq(data.businessType, data.searchType, (data.searchType === 'POL' ) ? data.value : data.value.replaceAll('-', '') )
        }
        
    }
    
    const CnicInput = (props) => {
        return (
            <InputMask 
                mask='99999-9999999-9' 
                maskChar={'_'}
                value={props.value} 
                onChange={props.onChange}
                placeholder='Eg: 99999-9999999-9'
                className='input_text'
                //name='value' {...register("value", {required:true})} >
                name='value' {...register("value")} >
            </InputMask>
        )
    }

    const PolicyInput = (props) =>{
        return (
            <InputMask
                mask="aa99999999999999999"
                maskChar={'_'}
                value= {props.value}
                onChange={props.onChange}
                placeholder='Eg: UL20160000671307005'
                className='input_text'
                //name='value' {...register("value", {required:true})}>
                name='value' {...register("value")}>
            </InputMask>
        )
    }

    const AgentInput = (props) =>{
        return (
            <InputMask
                mask="**********"
                maskChar={'_'}
                value= {props.value}
                onChange={props.onChange}
                placeholder='Eg: A000000000'
                className='input_text'
                name='value' {...register("value", {required:true})}>
            </InputMask>
        )
    }
    
    return(

        <div className='dashboard'>
            
            <Row className='main-heading'>
                <Col md={24}>
                    <Title level={2}>Policy Enquiry</Title>
                </Col>
            </Row>
            
            <form onSubmit={handleSubmit(onSubmit)} autoComplete='false'>
                <Row type="flex" align="middle" className='search-policy'>
            
                    <Col xs={24} sm={6} md={3} className='back back-white'>
                        <select className='classic' style={{ verticalAlign: 'middle' }}
                            {...register("searchType", { onChange: (e) => handleChange(e), required: true } ) }>
                            {searchTypes.map((searchType, key) => (
                                <option value={searchType['slug']} key={key}>{searchType['text']}</option>
                            ))}
                        </select>
                    </Col>
                    
                    <Col xs={24} sm={18} md={6} className='back back-white'>
                        {{
                            'POL': <PolicyInput />,
                            'CNIC': <CnicInput />,
                            'AGENT': <AgentInput />
                        }[optionChange]}
                    </Col>
                
                    <Col xs={24} sm={6} md={4} className='back back-white'>
                        <select style={{ verticalAlign: 'middle' }} defaultValue={storageBusinessType.line_of_business} {...register("businessType", {required:true})}  >
                            { businessTypes.map((businessType, key) => (
                                <option 
                                disabled={ storageBusinessType.line_of_business == 'BOTH' ? false : true } 
                                value={businessType['slug']} key={businessType['slug']} >{businessType['text']}</option>
                            ))}
                        </select>
                    </Col>
                
                    <Col className='back back-official'>
                        <Tooltip title="Search">
                            <Button type="ghost" htmlType="submit" icon={<SearchOutlined />} />
                        </Tooltip>
                    </Col>
                </Row>
            </form>

            <Row>
                <Col md={24}>
                    {( () => {
                        if(loading){
                            return(
                                <Loader />
                            )
                        }else{
                            const column = policyDetailColumn.filter(function(item) {
                                if(item.dataIndex == 'LOB_CODE' ){
                                    return false
                                }else{
                                    return true
                                }
                            });
                            return (
                                <Table
                                    className='back-white' 
                                    style={{ margin: '25px 2px 2px 2px', padding: '12px' , borderRadius: '2px'}} 
                                    dataSource={policyDetail} columns={column} />
                            )
                        }
                        
                    }) ()}
                </Col>
            </Row>
            
        </div>
    )
}

export default IPolicyEnq